module.exports = __webpack_public_path__ + "static/media/Brookstone-Covenants-and-Restrictions.89cb943e.pdf";